var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8F8F8C",
  d: "M2.3 6.083a.7.7 0 0 1 .7-.7h18a.7.7 0 1 1 0 1.4H3a.7.7 0 0 1-.7-.7M5.3 12.083a.7.7 0 0 1 .7-.7h12a.7.7 0 1 1 0 1.4H6a.7.7 0 0 1-.7-.7M10 17.383a.7.7 0 1 0 0 1.4h4a.7.7 0 1 0 0-1.4z"
})));
export default SvgFilter;